import axios from 'axios';

export default {
    getMine(context) {
        var options = {
            url: window.apiUrl + '/my-lessons',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },

    clone(data) {
        var options = {
            url: window.apiUrl + '/video-clone',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data: data,
            method: 'POST'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },

    add(context, data) {
        var options = {
            url: window.apiUrl + '/video',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data: data,
            method: 'POST'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    addLessonFiles(context, data) {
        var options = {
            url: window.apiUrl + '/lesson-file',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data: data,
            method: 'POST'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    deleteLessonFile(context, id) {
        var options = {
            url: window.apiUrl + '/lesson-file/' + id,
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'DELETE'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    updateVideo(context, video) {
        var options = {
            url: window.apiUrl + '/video',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data: video,
            method: 'PATCH'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });

    },
    get(context, courseId, instanceId) {
        var options = {
            url: window.apiUrl + '/videos?courseId=' + courseId + '&instanceId=' + instanceId,
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getByWeek(context, instanceId, week) {
        var options = {
            url: window.apiUrl + '/video/?instanceId=' + instanceId + '&week=' + week,
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };

        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getOne(context, videoId, courseId, week) {
        var options = {
            url: window.apiUrl + '/video/' + videoId + '?courseId=' + courseId + '&week='+week,
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };

        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getAll(context) {
       
        var options = {
            url: window.apiUrl + '/videos',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET',
        }
         

        return axios.request(options).then(function(response) {
             return response;

        }).catch(function(error) {
            console.log('ERROR');
            console.log(error)
            return(error);

        });
    },
    getOne(context, videoId, instanceId, week) {
        var options = {
            url: window.apiUrl + '/video/' + videoId + '?instanceId='+instanceId+'&week='+week,
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };

        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    regenerateTranscript(context, chapterId, transcriptId, createNewTranscript, videoId) {
        let data = {createNewTranscript: createNewTranscript};
        
        if (createNewTranscript === true) {
            data.videoId = videoId;
        }

        var options = {
            url: window.apiUrl + '/transcript/' + chapterId + '/' + transcriptId,
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'PUT',
            data: data
        };

        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    deleteVideo(context, id, instanceId, week) {
        var data = {
            id: id,
            instanceId: instanceId,
            week: week
        }
        var options = {
            url: window.apiUrl + '/video',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'DELETE',
            data: data
        };

        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    deleteChapter(context, id) {
        var data = {
            id: id
        }
        var options = {
            url: window.apiUrl + '/video-chapter',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'DELETE',
            data: data
        };

        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    addAnnotation(context, data) {
        var options = {
            url: window.apiUrl + '/annotations',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'POST',
            data: data
        }; 
        return axios.request(options).then(function(response) {
            return response;
        });      
    },
    updateAnnotation(context, data) {
        var options = {
            url: window.apiUrl + '/annotations/' + data.id,
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'PUT',
            data: data
        }; 
        return axios.request(options).then(function(response) {
            return response;
        });      
    },
    deleteAnnotation(context, id) {
        var options = {
            url: window.apiUrl + '/annotations',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'DELETE',
            data: {id: id}
        }; 
        return axios.request(options).then(function(response) {
            return response;
        });
      
    },
    reorder(context, order) {
        var options = {
            url: window.apiUrl + '/chapters/reorder',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'PUT',
            data: order
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    
    },
    update(context, key, value, id) {
         var options = {
            url: window.apiUrl + '/chapters',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'PUT',
            data: {
                key: key,
                value: value,
                id: id
            }
        };   

        return axios.request(options).then(function(response) {
            return response;
        })
    },
    addChapters(context, chapters) {
        var options = {
            url: window.apiUrl + '/chapters',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'POST',
            data: chapters
        };

        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    addComment(context, comment) {
        var options = {
            url: window.apiUrl + '/video-comment',
            method: 'POST',
            data: comment,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        }); 
    },

    getComments(context, chapterId) {
        var options = {
            url: window.apiUrl + '/video-comment/' + chapterId,
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        }); 
    },
    updateTranscript(context, transcript) {
        var data = {
            transcript: transcript.text
        }
        var options = {
            url: window.apiUrl + '/transcript/' + transcript.id,
            method: 'PATCH',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            console.log(response);
            return response;        
        }).catch(function(e) { console.log(e);})
    }

};



// WEBPACK FOOTER //
// ./src/services/videos/index.js